import { AuthState } from './types'
import { AUTH_TOKEN_KEY } from '../../../core/constants'

export const state: AuthState = {
  isAuthenticated: !!localStorage.getItem(AUTH_TOKEN_KEY) || sessionStorage.getItem(AUTH_TOKEN_KEY),
  currentUser: {},
  allFieldIsValid: false
}

